import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-confirmation-modal',
	imports: [CommonModule],
	templateUrl: './confirmation-modal.component.html',
	styleUrl: './confirmation-modal.component.scss',
})
export class ConfirmationModalComponent {
	@Input() title: string;
	@Input() contentText: string;
	@Input() confirmButtonColur: 'btn-outline-primary' | 'btn-primary' | 'btn-outline-danger' | 'btn-danger' = 'btn-outline-danger';
	@Input() backButtonColour: 'btn-outline-primary' | 'btn-primary' | 'btn-outline-danger' | 'btn-danger' = 'btn-primary';
	@Output() confirmAction = new EventEmitter<void>();
	private activeModal = inject(NgbActiveModal);

	closeModal(): void {
		this.activeModal.close();
	}

	confirm(): void {
		this.confirmAction.emit();
		this.closeModal();
	}
}
